// The signed-in places, in sidebar order (MacMain, d37). The sidebar, the
// rail, the router's meta and the tests all read this one table. Icons are
// 24-unit outlines drawn at stroke 1.9 with round caps.

export const SECTIONS = ["Sessions", "Sounds", "Library", "Social"];

export const PLACES = [
  { id: "mine", label: "Mine", section: "Sessions", path: "/sessions/mine", icon: "M4 10v4M8 7v10M12 4v16M16 8v8M20 11v2", count: "quiet" },
  {
    id: "friends",
    label: "Friends",
    section: "Sessions",
    path: "/sessions/friends",
    icon: "M9 11a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6ZM2.8 19.5c.7-3.3 3.1-5 6.2-5s5.5 1.7 6.2 5M15.5 4.9a3.3 3.3 0 0 1 0 6.3M18 14.8c1.8.6 3 2.2 3.4 4.7",
    count: null,
  },
  {
    id: "live",
    label: "Live",
    section: "Sessions",
    path: "/sessions/live",
    icon: "M12 12h.01M8.5 15.5a5 5 0 0 1 0-7M15.5 8.5a5 5 0 0 1 0 7M5.6 18.4a9 9 0 0 1 0-12.8M18.4 5.6a9 9 0 0 1 0 12.8",
    count: "quiet",
    // Unselected, the Live glyph is green (cl_sidebar.dart).
    iconColor: "var(--cl-live)",
  },
  {
    id: "discover",
    label: "Discover",
    section: "Sessions",
    path: "/discover",
    icon: "M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM15.5 8.5l-2 5-5 2 2-5 5-2Z",
    count: null,
  },
  {
    id: "liked",
    label: "Liked",
    section: "Sessions",
    path: "/discover/liked",
    icon: "M12 20s-7.5-4.4-7.5-10A4.3 4.3 0 0 1 12 7.3 4.3 4.3 0 0 1 19.5 10c0 5.6-7.5 10-7.5 10Z",
    count: "quiet",
    // d35: the row and its rail button show only while something is liked.
    onlyWhenCounted: true,
  },
  { id: "browse", label: "Browse", section: "Sounds", path: "/sounds", icon: "M3 12h2M7 8v8M11 5v14M15 9v6M19 7v10", count: null },
  {
    id: "packs",
    label: "Packs",
    section: "Sounds",
    path: "/packs",
    icon: "M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5v-9ZM3.5 7.5 12 12l8.5-4.5M12 12v9",
    count: null,
  },
  {
    id: "my-audio",
    label: "My audio",
    section: "Library",
    path: "/library/my-audio",
    icon: "M9 18V5l11-2v13M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM20 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
    count: null,
  },
  {
    id: "favorites",
    label: "Favorites",
    section: "Library",
    path: "/library/favorites",
    icon: "M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9 6.8 19.6l1-5.8-4.3-4.1 5.9-.9L12 3.5Z",
    count: null,
  },
  { id: "people", label: "People", section: "Social", path: "/people", icon: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4.5 20.5c1-4 4-6 7.5-6s6.5 2 7.5 6", count: null },
  {
    id: "inbox",
    label: "Inbox",
    section: "Social",
    path: "/inbox",
    icon: "M3 13h5l1.5 3h5L16 13h5M5 5h14l2 8v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6l2-8Z",
    count: "badge",
  },
];

export const SESSION_PLACES = ["mine", "friends", "live", "liked"];

export function placeById(id) {
  return PLACES.find((p) => p.id === id) || null;
}

// The count a place shows, or null to hide it: quiet counts and the badge
// are hidden when unknown, empty or 0. `counts` is { mine, live, liked,
// inbox }.
export function countFor(place, counts = {}) {
  if (!place || !place.count) return null;
  const n = Number(counts[place.id]);
  return Number.isFinite(n) && n > 0 ? n : null;
}

// Places a list shows: Liked only while its count is above 0 (the app's
// rail, d35).
export function visiblePlaces(counts = {}) {
  return PLACES.filter((p) => !p.onlyWhenCounted || countFor(p, counts) != null);
}

// The sidebar's sections with their visible places.
export function sidebarSections(counts = {}) {
  const shown = visiblePlaces(counts);
  return SECTIONS.map((title) => ({ title, places: shown.filter((p) => p.section === title) }));
}

// The rail's buttons: one per place, in table order.
export function railPlaces(counts = {}) {
  return visiblePlaces(counts);
}

// The list beside an open session for a session place.
export function sessionPlacePath(id) {
  const p = placeById(SESSION_PLACES.includes(id) ? id : "mine");
  return p.path;
}
